
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'eddydata-lib';
import { AvisoListComponent } from './aviso-list/aviso-list.component';
import { AvisoFormComponent } from './aviso-form/aviso-form.component';

const routes: Routes = [
    { path: '', component: AvisoListComponent, canActivate: [AuthGuard] },
    { path: 'novo', component: AvisoFormComponent, canActivate: [AuthGuard] },
    { path: ':id/editar', component: AvisoFormComponent, canActivate: [AuthGuard] },
    { path: ':id/visualizar', component: AvisoFormComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AvisoRoutingModule { }